<template>
	<div class="chinaEuropeTrain">

		<Header :typeHeader="'defaultHeader'">
			<!-- banner -->
			<img slot="headerImage" :src="imgList.bannerImg" alt="">
			<!-- 标题 -->
			<div slot="headerTitle">{{$store.state.navShow == true ? '海铁联运' : 'transport'}}</div>
			<div style="font-size: 1.125rem; color: #FFFFFF; font-weight: 100; margin-top: 0.6rem;" slot="headerTitle">
				{{$store.state.navShow == true ? '铁路运输及国际海运':'rail transport and international shipping'}}</div>
		</Header>

		<div class="TopTitle" data-aos="fade-up">
			<div class="">
				 {{$store.state.navShow == true ? $route.name : $route.meta.EnName}}
			</div>
		</div>
		<div class="ContentText" data-aos="fade-down">
			<p> {{$store.state.navShow == true ? ' MG集团是专业的国际铁路运输服务商，在俄罗斯本土拥有强大的铁路运输资源优势，在海运方面拥有十多年的运营经验，拥有专业化管理团队和精细化运营模式，打造了海铁联运精品线路：通过海运可由天津、上海、宁波等国内20多个城市至海参崴换乘铁路、汽运等运输方式，到俄罗斯境内莫斯科/圣彼得堡/叶卡捷琳堡/明斯克清关，为客户提供多种运输补充方案及高效、便捷安全的服务。' : 'MG Group is a professional international railway transportation service provider. It has strong advantages in railway transportation resources in Russia. It has more than ten years of operational experience in shipping, and has a professional management team and refined operation model. It has created a high-quality sea-rail combined transportation. Route: From more than 20 domestic cities such as Tianjin, Shanghai, Ningbo, etc. to Vladivostok by sea, transfer to railway, automobile and other modes of transportation to Moscow / Saint Petersburg / Yekaterinburg / Minsk for customs clearance in Russia, providing customers with a variety of supplementary transportation solutions and Efficient, convenient and safe service.'}}</p>
		</div>

		<div class="table">
			<el-table class="seaRail" :data="$store.state.navShow == true ? tableData : tableDataE" border :header-cell-style="headMerge" style="width: 100%">
				<el-table-column prop="startPlace" :label="$store.state.navShow == true ?'出发地':'Departure'">
					<!-- 相当于td 为了让内容换行和好修饰 -->
					<template slot-scope="scope">
						<!-- <p @mouseover="aaa(scope)">111111111</p> -->
						<!-- v-html为了渲染 br -->
						<p class="tdContent" v-html="scope.row.startPlace"></p>
					</template>
				</el-table-column>

				<el-table-column prop="seaLine" :label="$store.state.navShow == true ? '海运线':'Shipping line'">
					<template slot-scope="scope">
						<!-- <p @mouseover="aaa(scope)">111111111</p> -->
						<!-- v-html为了渲染 br -->
						<p class="tdContent" v-html="scope.row.seaLine"></p>
					</template>
				</el-table-column>

				<el-table-column prop="trainLine" :label="$store.state.navShow == true ? '铁路线':'Railway'">
					<template slot-scope="scope">
						<!-- v-html为了渲染 br -->
						<p class="tdContent" v-html="scope.row.trainLine"></p>
					</template>
				</el-table-column>
<!-- 
				<el-table-column prop="trainLine1">
					<template slot-scope="scope">
						v-html为了渲染 br
						<p class="tdContent" v-html="scope.row.trainLine1" ></p>
					</template>
				</el-table-column> -->

			</el-table>
		</div>
		<p class="tableTitleTitle">{{$store.state.navShow == true ? '海铁联运精品线路' : 'Sea-rail combined transportation boutique line'}}</p>
		<p class="tableTitlePText"> {{$store.state.navShow == true ? '天津、青岛、上海、宁波等港口出发到达海参崴（海运）莫斯科清关、港务方面的优势及铁路线路资源——' : 'Departure from Tianjin, Qingdao, Shanghai, Ningbo and other ports to Vladivostok (maritime) Moscow’s advantages in customs clearance, port affairs and railway line resources——'}}</p>

		<div class="ContenImg" >
			<img :src="$store.state.navShow == true ? imgList.maps : imgList.mapsE">
		</div>

		<div class="ContenImg_2" data-aos="fade-up">
			<img class="ContenImg_2_1" :src=" $store.state.navShow == true ? imgList.textimg : imgList.textimgE">
			<img class="ContenImg_2_2" :src="imgList.textimg2">
		</div>

		<div class="buttonImgCOS">
			<img src="../../../assets/chinaEurope/chinaEurope07.png">
		</div>
	</div>
</template>

<script>
	import Header from "@/components/header.vue";
	export default {
		components: {
			Header,
		},
		data() {
			return {
				// 表格
				tableData: [{
					startPlace: '天津 / 上海 / 宁波 <br>等国内20多个城市',
					seaLine: '海参崴（俄罗斯）',
					trainLine: '莫斯科/圣彼得堡/叶卡捷琳堡/明斯克',
					trainLine1: '塔什干<br>（乌兹别克斯坦）'
				}],
				tableDataE: [
					{
						startPlace: 'More than 20 cities in China such as Tianjin/Shanghai/Ningbo',
						seaLine: 'Vladivostok (Russia)',
						trainLine: 'Moscow / St. Petersburg / Yekaterinburg / Minsk',
						trainLine1: '塔什干<br>（乌兹别克斯坦）'
					}
				],
				imgList: {
					bannerImg: require('@/assets/chinaEurope/banner2.jpg'),
					maps: require('@/assets/chinaEurope/map.jpg'),
					textimg: require('@/assets/chinaEurope/text.png'),
					mapsE: require('@/assets/chinaEurope/mapE.jpg'),
					textimgE: require('@/assets/chinaEurope/textE.png'),
					textimg2: require('@/assets/chinaEurope/buttonimg.png'),
				},
			}
		},
		methods: {

			// aaa(o){
			//     console.log("! => ",o)
			// },
			headMerge({
				row,
				column,
				rowIndex,
				columnIndex
			}) {

				if (columnIndex === 2) {
					//  $nextTick 等待Dom更新完成之后才会走里边的函数
					this.$nextTick(() => {
						document.querySelector(`.${column.id}`).setAttribute('colspan', 2)
					})
				}
				if (columnIndex === 3) {
					return {
						display: 'none'
					}
				}
				return {
					color: '#2E67B1',
					textAlign: 'center'
				}
			}

		}
	}
</script>

<style lang="less">
	.chinaEuropeTrain {
		background-color: #FFF;
	}
	.TopTitle {
		width: 92%;
		height: 4.95rem;
		position: relative;
		margin: 0 4%;
		top: -3.2rem;
		border-bottom: 1px solid rgba(204, 204, 204, .5);

		&>div {
			position: absolute;
			top: 1.25rem;
			font-size: 1rem;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			padding: 1.2rem 3.375rem 1.2rem 0.75rem;
			background: #2e67b1 linear-gradient(270deg, rgba(3, 0, 0, .15), hsla(0, 0%, 100%, .15));
		}
	}

	.ContentText {
		width: 92%;
		margin: 0 4%;
		// background-color: #000066;
		margin-top: -1.575rem;
		text-align: left;

		&>p {
			font-size: 0.875rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			text-indent: 2em;
			margin-bottom: 1.25rem;
			text-align: justify;
		}
	}







	.tableTitleTitle {
		width: 92%;
		margin: 1.875rem 4% 0.625rem 4%;
		// margin: 1.875rem 0 0.625rem 0;
		
		font-size: 0.95rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #2E67B1;
		// text-align: left;
	}

	.tableTitlePText {
		width: 92%;
		margin: 0 4% ;
		font-size: 0.699rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
		text-align: left;
		text-indent: 2em;
	}

	.table {
		.el-table {
			.el-table__header-wrapper {
				.el-table__header {
					thead {
						tr {
							th{
								background-color: #eaf0f7 !important;
							}
						}
					}
				}
			}
		}
		.el-table__cell {
			background-color: #eaf0f7;
		}
		width: 92%;
		margin: 0 4%;

		.tdContent {
			text-align: center;
			line-height:0.825rem;
			
		}
	}

	.ContenImg {
		width: 100%;
		height: 14.3125rem;
		min-height: 14.3125rem;
		margin-top: 2.0875rem;
		// margin-bottom: 1.0875rem;

		&>img {
			width: 100%;
			height: 100%;
		}
	}

	.ContenImg_2 {
		width: 100%;
		height: 16.3125rem;
		margin-bottom: 1.0875rem;
		position: relative;

		&>img {
			position: absolute;
			left: 0;
		}

		.ContenImg_2_1 {
			width: 100%;
			height: 100%;
			top: 0;
		}

		.ContenImg_2_2 {
			height: 65%;
			bottom: -10%;
		}
	}



	.buttonImgCOS {
		width: 100%;
		height: 3.125rem;
		margin-top: 0.78125rem;
	}
</style>
